import type { PropsWithChildren } from "react";

import { Box } from "@aircall/tractor";

import { useAccordionItem } from "../../contexts/hooks/useAccordionItem";

import type { AccordionHeaderProps } from ".";

export function AccordionHeader({
  children,
  ...props
}: PropsWithChildren<AccordionHeaderProps>) {
  const { id } = useAccordionItem();

  return (
    <Box data-test={`accordion-header-${id}`} {...props}>
      {children}
    </Box>
  );
}
